import {useOutput} from '@autocut/contexts/OutputContext';
import {Button} from '@autocut/designSystem/components/atoms/Button/Button';
import {preload} from '@autocut/types/ElectronPreload';

export const GetRessourcesPath = () => {
  const {setOutput} = useOutput();

  const handleOnClick = () => {
    try {
      const ressourcesPath = preload.electron.getPath('userData');
      setOutput(ressourcesPath);
    } catch (error) {
      setOutput('Error getting ressources path : ' + error);
    }
  };

  return (
    <Button
      size="sm"
      variant="secondary"
      fullWidth={false}
      onClick={handleOnClick}
    >
      Get Ressources Path
    </Button>
  );
};
